'use strict';

angular.module('imagetrend.components')
    .directive('hlpField', ['$templateCache', function ($templateCache) {
        return {
            scope: {
                // strings
                name: '@?',
                id: '@?',
                label: '@?',
                title: '@?',
                requiredText: '@?',
                classes: '@?',
                instructions: '@?',
                blankText: '@?',
                selectShow: '@?',
                selectSort: '@?',
                selectValue: '@?',
                availableShow: '@?',
                availableSort: '@?',
                compareValue: '@?',
                arrayValue: '@?',
                service: '@?',
                method: '@?',
                groupBy: '@?',
                size: '@?',
                maxLength: '@?',
                placeholder: '@?',

                // bools
                showBlank: '=?',
                showLabel: '=?',
                topLabel: '=?',
                showColon: '=?',
                modal: '=?',
                isRequired: '=?',
                showRequired: '=?',
                isDisabled: '=?',
                forceString: '=?',
                serviceOverride: '=?',
                multiple: '=?',
                sortable: '=?',
                vertical: '=?',
                pdf: '=?',
                innerForm: '=?'
            },
            transclude: true,
            template: function () {
                return $templateCache.get('templates/field/field.html');
            },
            compile: function (elem, attrs) {
                return {
                    pre: function (scope, elem, attrs, ngModel) {
                        scope.directiveAttributes = attrs;
                    },
                    post: function (scope, elem, attrs, ngModel) {

                        scope.$on('$destroy', function () {
                            if (elem) {
                                angular.element(elem).off();
                                angular.element(elem).remove();
                                elem = null;
                            }
                        });
                    }
                }
            }
        };
    }])

;